import { z } from 'zod'

export const PiloteEveningStatusZod = z.enum(['INACTIVE', 'OPEN', 'CLOSED'])
export type PiloteEveningStatus = z.infer<typeof PiloteEveningStatusZod>

export const PiloteEveningRecordZod = z.object({
  id: z.number(),
  campaign_id: z.number(),
  date: z.string(),
  status: PiloteEveningStatusZod.nullable(),
  is_mobile_request_enabled: z.boolean(),
  is_full: z.boolean().optional().default(false),
  number: z.number(),
  version: z.number(),
})
export type PiloteEveningRecord = z.infer<typeof PiloteEveningRecordZod>
